import { defineStore } from 'pinia'

import type { SubscriptionStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'
import { UpcomingLessonsPauseStatus } from './enums'

export const useSubscriptionStore = defineStore('subscription', {
  state: (): SubscriptionStore => ({
    loading: false,
    loaded: false,
    availableProductsLoading: false,
    subscriptions: [],
    subscription: null,
    paymentRetryData: null,
    bannerPaymentRetry: false,
    bannerPaymentRetryProcessing: false,
    modalPaymentRetry: false,
    modalPaymentRetryProcessing: false,
    modalPaymentRetrySuccess: false,
    modalSubscriptionPauseResume: false,
    modalSubscriptionPause: null,
    modalSubscriptionPauseDuration: false,
    modalSubscriptionPauseReason: false,
    modalSubscriptionFurtherPayments: null,
    modalSubscriptionPauseSuccess: false,
    pauseDuration: null,
    pauseReason: null,
    pauseDetails: null,
    pauseContactRequest: false,
    availableProducts: [],
    upcomingLessonsPauseStatus: UpcomingLessonsPauseStatus.KeepLearning,
  }),
  actions,
  getters,
})
